import sha256 from 'crypto-js/sha256'
import md5 from 'md5'
import BigNumber from './bignumber.mjs'

class Util {

  stringToCapitalize(str) {
    var arr = str.toLowerCase().split('_');
    arr = arr.map(function(val) {
      if (val == 'new') {
        val = 'place'
      }
      val = val.slice(0, 1).toUpperCase() + val.slice(1);
      return val
    })
    return arr.join(' ')
  }

  /**
   * cookie操作
   */
  setCookie(name, value, options) {
    options = options || {};
    if (value === null) {
      value = '';
      options.expires = -1;
    }
    var expires = '';
    if (options.expires && (typeof options.expires == 'number' || options.expires.toUTCString)) {
      var date;
      if (typeof options.expires == 'number') {
        date = new Date();
        date.setTime(date.getTime() + (options.expires * 24 * 60 * 60 * 1000));
      } else {
        date = options.expires;
      }
      expires = '; expires=' + date.toUTCString(); // use expires attribute, max-age is not supported by IE
    }
    var path = options.path ? '; path=' + options.path : '';
    var domain = options.domain ? '; domain=' + options.domain : '';
    var s = [cookie, expires, path, domain, secure].join('');
    var secure = options.secure ? '; secure' : '';
    var c = [name, '=', encodeURIComponent(value)].join('');
    var cookie = [c, expires, path, domain, secure].join('')
    document.cookie = cookie;
  }

  getCookie(name) {
    var cookieValue = null;
    if (document.cookie && document.cookie != '') {
      var cookies = document.cookie.split(';');
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        // Does this cookie string begin with the name we want?
        if (cookie.substring(0, name.length + 1) == (name + '=')) {
          cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
          break;
        }
      }
    }
    return cookieValue;
  }

  setSession(key, value){
    value = JSON.stringify(value);
    // console.log(value);
    sessionStorage.setItem(key, value);
  }

  getSession(key){
    if (key == "") return "";
    let value = sessionStorage.getItem(key);
    if (value == ""){
      return "";
    }
    return value;
  }

  // 数字千分位，保留n位小数格式化
  addCommas(nStr, n = 2) {
    let tmp = new BigNumber(nStr).toFixed(n)-0;
    return new BigNumber(tmp).toFormat();
  }

  // 获取加密code和time
  getCodeTime(){
    let key = 'SQscorK9G1ZnlCPo';
    let timestamp = (Date.parse(new Date()))/1000;
    let code = md5(timestamp+sha256(key+timestamp)+timestamp);
    return '&code='+code+'&time='+timestamp;
  }

  // 过滤字符串中的空格
  trimString(str){
    return str.replace(/\s*/g, '');
  }

  // 判断终端
  browserVersions() {
    var u = navigator.userAgent.toLowerCase();
    return {
      android: u.indexOf('android') > -1 || u.indexOf('adr') > -1, //android终端
      iPhone: u.indexOf('iphone') > -1, //是否为iPhone或者QQHD浏览器
      Safari: !!u.match(/version\/([\d.]+).*safari/), //是否为Safari浏览器
      weixin: u.indexOf('micromessenger') > -1, //是否微信
      mdsApp: u.indexOf('mdsapp') > -1, //是否MdsApp
      mdsVer: u.indexOf('mdsapp') > -1 ? u.match(/mdsapp\/[^\s]+\s?/)[0].trim().split('/')[1] : '0' //MdsApp版本
    };
  }

  getEthereum() {
    return new Promise(function(resolve, reject){
      var tries = 0;

      var timer = setInterval(function(){
        tries++;
        if(window.ethereum){
          clearInterval(timer);
          resolve(window.ethereum);
        }
        if(tries > 10){
          clearInterval(timer);
          reject(false);
        }
      }, 100);
    });
  }

  hex2str(hex) {
    var trimedStr = hex.trim();
    var rawStr = trimedStr.substr(0, 2).toLowerCase() === "0x" ? trimedStr.substr(2) : trimedStr;
    var len = rawStr.length;
    if (len % 2 !== 0) {
      alert("Illegal Format ASCII Code!");
      return "";
    }
    var curCharCode;
    var resultStr = [];
    for (var i = 0; i < len; i = i + 2) {
      curCharCode = parseInt(rawStr.substr(i, 2), 16);
      resultStr.push(curCharCode);
    }
    // 默认utf-8
    let bytesView = new Uint8Array(resultStr);
    let str = new TextDecoder().decode(bytesView);
    return new String(str).toString();
  }

  // 去除右边填充0
  rightZerosStrip(hexStr){
    if (hexStr.length <=0 ){
      return '0x';
    }
    let len = hexStr.length-1;
    for (let i=len; i>0;i=i-2){
      if (hexStr.substr(-2)-0 == 0){
        hexStr = hexStr.substr(0, hexStr.length-2);
      } else{
        break;
      }
    }
    return hexStr;
  }

  formatBalance(balance, decimals){
    return new BigNumber(balance)
      .div(Math.pow(10, decimals))
      .toFixed(4, 3);
  }
}

let util = new Util;

export default util;
